/** Logical width used by placement, navigation, snapping, and clearance. */
export const ROAD_WIDTH = 4.2;

/** Maximum authored lateral wobble of either opaque road edge. */
export const ROAD_CORE_EDGE_JITTER_RATIO = 0.22 / ROAD_WIDTH;

/** Roads retain their logical footprint but render at two thirds of that width. */
export const ROAD_VISUAL_WIDTH_SCALE = 2 / 3;

/** Dry roads retain terrain clearance, with the feathered shoulder above the core. */
export const ROAD_VISUAL_CORE_Y_OFFSET = 0.055;
export const ROAD_VISUAL_SHOULDER_Y_OFFSET = 0.065;

/** Slim presentation-only paths from road-connected buildings to the road. */
export const BUILDING_ACCESS_SPUR_WIDTH = ROAD_WIDTH * ROAD_VISUAL_WIDTH_SCALE * 0.4;
/** Keeps overlapping spur/main-road triangles stable without clearing building pads. */
export const BUILDING_ACCESS_SPUR_Y_LIFT = 0.003;

/** Bridge clearance remains independent from the lower dry-road presentation. */
export const ROAD_BRIDGE_CORE_Y_OFFSET = 0.12;
export const ROAD_BRIDGE_SHOULDER_LIFT = 0.1;
/** Shared dirt/timber boundary used by both the bridge shader and approach hubs. */
export const BRIDGE_SURFACE_CUT_THRESHOLD = 0.018;
/** Physical repeat scale of the authored bridge timber surface. */
export const BRIDGE_DECK_TEXTURE_METERS_PER_TILE = 2;

export function roadVisualWidth(logicalWidth: number): number {
  return Math.max(0, logicalWidth) * ROAD_VISUAL_WIDTH_SCALE;
}

/** Half-width that a junction must cover, including the road's irregular edge. */
export function roadCoreMaximumHalfWidth(visualWidth: number): number {
  return Math.max(0, visualWidth) * (0.5 + ROAD_CORE_EDGE_JITTER_RATIO);
}
